import { h, Component } from "preact";
import copyToClipboard from "copy-to-clipboard";

import copyIcon from "./images/copy.svg";

class copyToClipboardCompoennt extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.copy = this.copy.bind(this);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  copy(link) {
    copyToClipboard(link);

    this.setState({
      copyd: true
    });

    this.timer = setTimeout(
      () =>
        this.setState({
          copyd: false
        }),
      1000
    );
  }

  render({ text }, { copyd }) {
    return (
      <div class="user-widget__copy_to_clipboard">
        <button onClick={() => this.copy(text)}>
          <img src={copyIcon} alt="copy" />
        </button>
        {copyd && (
          <span class="user-widget__copy_to_clipboard__info">
            copied to clipboard
          </span>
        )}
      </div>
    );
  }
}

export default copyToClipboardCompoennt;



// WEBPACK FOOTER //
// ./src/CopyToClipboard.js